import React, {PureComponent, ComponentClass, RefObject} from "react"
import {Branding} from "@irati/types"
import BrandingStream from "./streams/branding"
import type {ZenObservable} from "zen-observable"

export interface WithBranding {
  branding: Branding
}

export default function withBranding<Props>(
  Comp: React.ComponentType<Props & WithBranding>,
  {withRef = false} = {}
): ComponentClass<Pick<Props, Exclude<keyof Props, keyof WithBranding>>> & {WrappedComponent: React.ComponentType<Props & WithBranding>} {
  type PrivateProps = {
    forwardedRef?: RefObject<typeof Comp>
  }

  type State = {
    branding: Branding
  }

  class WrappedComponent extends PureComponent<PrivateProps & Props, State> {
    state: State = {
      branding: BrandingStream.get() || {}
    }

    observer: ZenObservable.Subscription | null = null

    componentDidMount() {
      this.observer = BrandingStream.subscribe((branding) => {
        this.setState({branding})
      })
    }

    componentWillUnmount() {
      if (this.observer) {
        this.observer.unsubscribe()
      }
    }

    render() {
      const {forwardedRef, ...rest} = this.props as PrivateProps
      const props = rest as Props

      return <Comp ref={forwardedRef} {...props} branding={this.state.branding} />
    }
  }

  if (withRef) {
    return React.forwardRef<typeof Comp, Props>((props, ref) => {
      return <WrappedComponent {...props} forwardedRef={ref} />
    })
  }

  return WrappedComponent
}
